import { render, staticRenderFns } from "./LeadContactActions.vue?vue&type=template&id=2ebcd8f4"
import script from "./LeadContactActions.vue?vue&type=script&lang=js"
export * from "./LeadContactActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports